'use client';
import { Search as SearchIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { CandidateFilters } from '@/types/candidate';
import ActiveFilterChips from './active-filter-chips';
import FilterMenu from './filter-menu';
import LayoutSwitcher from './layout-switcher';

type ViewControlsProps = {
  mode: 'kanban' | 'table';
  onModeChange: (mode: 'kanban' | 'table') => void;
  search: string;
  onSearchChange: (value: string) => void;
  filters: CandidateFilters;
  onFiltersChange: (value: CandidateFilters) => void;
  onFiltersReset?: () => void;
  className?: string;
  disableModeToggle?: boolean;
};

const ViewControls = ({
  mode,
  onModeChange,
  search,
  onSearchChange,
  filters,
  onFiltersChange,
  onFiltersReset,
  className,
  disableModeToggle = false,
}: ViewControlsProps) => {
  return (
    <div className={cn('flex flex-wrap flex-col gap-3 sm:flex-row sm:items-center sm:justify-between', className)}>
      <ActiveFilterChips
        filters={filters}
        onFiltersChange={onFiltersChange}
        onFiltersReset={onFiltersReset}
      />
      <div className="flex flex-wrap w-full items-center justify-end gap-2 ml-auto sm:w-auto">
        <LayoutSwitcher mode={mode} onModeChange={onModeChange} disabled={disableModeToggle} />
        <FilterMenu
          filters={filters}
          onFiltersChange={onFiltersChange}
          onFiltersReset={onFiltersReset}
          className="sm:w-auto"
        />
        <label className="flex h-10 w-full items-center gap-2 rounded-md border border-slate-200 bg-white px-3 text-sm focus-within:ring-2 focus-within:ring-primary sm:w-48">
          <SearchIcon className="h-4 w-4 text-slate-500" />
          <span className="sr-only">Zoek</span>
          <input
            type="search"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Zoek kandidaten..."
            className="h-full w-full bg-transparent text-sm outline-none"
          />
        </label>
      </div>
    </div>
  );
};

export default ViewControls;
